import React from 'react';
import PrintHeader from '../components/PrintPage/PrintHeader';
import AdressHeader from '../components/PrintPage/AdressHeader';
import MoneyContainer from '../components/PrintPage/MoneyContainer';
import DataTable from '../components/PrintPage/DataTable';
import AmountContainer from '../components/PrintPage/AmountContainer';

const Printpagecss = () => {
  return (
    <div className='flex justify-center'>
      <div className='flex flex-col'>
        <div className='a4-page flex flex-col p-5'>
          <div className=''>
            {/* 거래명세서와 주소내역 박스 */}
            <div className='grid grid-cols-[90mm_1fr]'>
              <AdressHeader />
              <PrintHeader />
            </div>
            <MoneyContainer />
            <DataTable />
            <AmountContainer />
            {/* 절취선 자리 */}
            <div className='w-full border-t border-dashed border-black mt-[5mm]'></div>

            {/* 거래명세서와 주소내역 박스 */}
            <div className='grid grid-cols-[90mm_1fr] mt-[5mm]'>
              <AdressHeader />
              <PrintHeader />
            </div>
            <MoneyContainer />
            <DataTable />
            <AmountContainer />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Printpagecss;
